import BankAccount from './BankAccount';

export default BankAccount;
